import React from 'react'
import QuestionnaireAdminTabs from 'components/QuestionnaireRequest/AdminNew/Tabs'
import { Provider } from 'react-redux'
import store from './store/store'

export default function QuestionnaireAdmin(props) {
  return (
    <Provider store={store}>
      <div className="super-questionnaire-request-container">
        <div className="page-header" style={{ margin: '-5px 0 20px' }}>
          <h4>Edit Organization: {props.organization.name}</h4>
        </div>
        <h2>Questionnaire</h2>
        <QuestionnaireAdminTabs {...props} />
      </div>
    </Provider>
  )
}
